import makeRequest from './client';

/** Snapshot change detection list + detail APIs (HttpResponse uses lowercase `status`). */
export type SnapshotComparisonApplicationsParams = {
  center?: string;
  application_number?: string;
  qc_status?: boolean;
  change_detection_status?: boolean;
  escalated_status?: boolean;
  all_verdict_false?: boolean;
  page?: number;
  page_size?: number;
};

export const getSnapshotComparisonApplications = (params: SnapshotComparisonApplicationsParams) => {
  const searchParams = new URLSearchParams();

  if (params.center) {
    searchParams.append('center', params.center);
  }
  if (params.application_number) {
    searchParams.append('application_number', params.application_number);
  }
  if (params.qc_status !== undefined) {
    searchParams.append('qc_status', String(params.qc_status));
  }
  if (params.change_detection_status !== undefined) {
    searchParams.append('change_detection_status', String(params.change_detection_status));
  }
  if (params.escalated_status !== undefined) {
    searchParams.append('escalated_status', String(params.escalated_status));
  }
  if (params.all_verdict_false !== undefined) {
    searchParams.append('all_verdict_false', String(params.all_verdict_false));
  }

  searchParams.append('page', String(params.page ?? 0));
  searchParams.append('page_size', String(params.page_size ?? 20));

  return makeRequest(`/snapshot_change_detection/application?${searchParams}`, 'GET');
};

export const getSnapshotComparisonApplicationDetail = (applicationNumber: string) =>
  makeRequest(
    `/snapshot_change_detection/application/${encodeURIComponent(applicationNumber)}`,
    'GET'
  );

/** Hardcoded PLR / non-PLR label section lists for Sections Changed editing. */
export const getSnapshotComparisonLabelSections = () =>
  makeRequest('/snapshot_change_detection/label_sections', 'GET');

/** Persists SME review fields for a single label comparison row. */
export type UpdateSmeVerdictPayload = {
  label_id: number;
  sme_verdict: boolean;
  sme_comments?: string | null;
  section_changed?: string[] | null;
};

export const updateSnapshotComparisonSmeVerdict = (payload: UpdateSmeVerdictPayload) =>
  makeRequest('/snapshot_change_detection/application/sme_verdict', 'POST', payload);

export type SnapshotChangeDetectionResourcePayload = {
  s3_path: string;
  center: string;
};

/** Returns a signed S3 URL for a letter document. */
export const getSnapshotChangeDetectionResource = (
  payload: SnapshotChangeDetectionResourcePayload
) => makeRequest('/snapshot_change_detection/resource', 'POST', payload);
